export enum FilterOperator {
  contains = 'CONTAINS',
  equal = '=',
  greaterThan = '>',
  greaterThanEqual = '>=',
  in = 'IN',
  isEmpty = 'IS EMPTY',
  isNotEmpty = 'IS NOT EMPTY',
  isNotNull = 'IS NOT NULL',
  isNull = 'IS NULL',
  lessThan = '<',
  lessThanEqual = '<=',
  notContains = 'NOT CONTAINS',
  notEqual = '!=',
  notIn = 'NOT IN',
}

export const OPERATOR_REQUIRES_NO_VALUE = {
  [FilterOperator.isEmpty]: true,
  [FilterOperator.isNotEmpty]: true,
  [FilterOperator.isNotNull]: true,
  [FilterOperator.isNull]: true,
};

export const OPERATOR_TAKES_PARENTHESES = {
  [FilterOperator.in]: true,
  [FilterOperator.notIn]: true,
};

export const requiresNoValue = (operator: FilterOperator) => {
  return !!(operator in OPERATOR_REQUIRES_NO_VALUE);
};

export const OPERATOR_SUGGESTIONS = [
  FilterOperator.greaterThanEqual,
  FilterOperator.lessThanEqual,
  FilterOperator.equal,
  FilterOperator.greaterThan,
  FilterOperator.lessThan,
  FilterOperator.notEqual,
  FilterOperator.contains,
  FilterOperator.notContains,
  FilterOperator.in,
  FilterOperator.notIn,
  FilterOperator.isEmpty,
  FilterOperator.isNotEmpty,
  FilterOperator.isNotNull,
  FilterOperator.isNull,
];
export const PREFIX_OPERATOR_SUGGESTIONS = ['NOT'];
export const GROUPING_OPERATOR_SUGGESTIONS = ['(', ')'];
export const GROUPING_OPERATOR_START = GROUPING_OPERATOR_SUGGESTIONS[0];
export const GROUPING_OPERATOR_END = GROUPING_OPERATOR_SUGGESTIONS[1];
export const VALUE_SUGGESTIONS: string[] = ['value1', 'value2', 'value3'];
export const LOGICAL_OPERATOR_SUGGESTIONS = ['AND', 'OR'];

export const EXPRESSION_START_REGEX = /^(\w*)$/;
export const OPERATOR_START_REGEX = /^\w+\s+([<>=!]*)$/;
export const VALUE_START_REGEX = /^\w+\s+(==|>=|<=|>|<|!=)\s+(['"]?)([^'"]*)?$/;

const escapeRegExp = (string: string): string =>
  string.replaceAll(/[.*+?^${}()|[\]\\]/g, String.raw`\$&`);

const operatorPattern = OPERATOR_SUGGESTIONS.map((str) => escapeRegExp(str)).join('|');

export const OPERATOR_REGEX = new RegExp(`(${operatorPattern})`);
export const VALUE_REGEX = /(['"])([^'"]*)\1/;
export const LOGICAL_OPERATOR_REGEX = /\b(AND|OR)\b/;

const allOperatorsPattern = `${operatorPattern}|${GROUPING_OPERATOR_SUGGESTIONS.map((str) => escapeRegExp(str)).join('|')}|${LOGICAL_OPERATOR_SUGGESTIONS.join('|')}`;

export const SPLIT_PATTERN = new RegExp(`(${allOperatorsPattern})|(\\S+)`, 'g');

export const splitChipValue = (value: string) => value.split(/([(),])/).filter(Boolean);

export const LOGICAL_OPERATOR_COLOR = '#C678DD'; // not in theme
export const FIELD_COLOR = 'primary.contrastText';
export const GROUPING_OPERATOR_COLOR = 'text.secondary';
export const CHIP_OUTLINE_COLOR = 'rgba(255, 255, 255, 0.26)';
export const OPERATOR_COLOR = '#D19A66'; // not in theme
export const VALUE_COLOR = '#98C379'; // not in theme
export const MENU_BACKGROUND_COLOR = '#2D2D2D'; // not in theme
export const TIP_INFO_ICON_COLOR = '#0E7090'; // not in theme

export const SuggestionLabel: Record<string, string> = {
  field: 'Fields',
  'grouping-operator': 'Grouping Operators',
  'logical-operator': 'Logical Operators',
  operator: 'Operators',
  'prefix-operator': 'Logical Operators',
  value: 'Values',
};

export const SuggestionLabelColor: Record<string, string> = {
  field: FIELD_COLOR,
  'logical-operator': LOGICAL_OPERATOR_COLOR,
  operator: OPERATOR_COLOR,
  'prefix-operator': LOGICAL_OPERATOR_COLOR,
  value: VALUE_COLOR,
};

const numericOperators = [
  FilterOperator.equal,
  FilterOperator.notEqual,
  FilterOperator.in,
  FilterOperator.lessThanEqual,
  FilterOperator.lessThan,
  FilterOperator.greaterThan,
  FilterOperator.greaterThanEqual,
];
const objectOperators = [
  FilterOperator.isEmpty,
  FilterOperator.isNotEmpty,
  FilterOperator.contains,
];
const generalOperators = [FilterOperator.equal, FilterOperator.notEqual, FilterOperator.in];
const allOperators = [
  FilterOperator.equal,
  FilterOperator.notEqual,
  FilterOperator.in,
  FilterOperator.isEmpty,
  FilterOperator.isNotEmpty,
  FilterOperator.lessThanEqual,
  FilterOperator.lessThan,
  FilterOperator.greaterThan,
  FilterOperator.greaterThanEqual,
  FilterOperator.contains,
];

const operatorsByDataTypeMap: {
  [key: string]: string[];
} = {
  any: allOperators,
  array: objectOperators,
  bool: generalOperators,
  date: numericOperators,
  datetime: numericOperators,
  enum: generalOperators,
  map: objectOperators,
  number: numericOperators,
  string: generalOperators,
  tuple: [],
  unknown: [],
  uuid: generalOperators,
};

export { operatorsByDataTypeMap };
